import PayRemainingSuccess from './PayRemainingSuccess';

export default PayRemainingSuccess;
